// @flow
import moment from 'moment';
import { WebinarItemState } from '../configs/types';
import { MuleRedDotFeatureList } from '../../home/types/muleCustStateType';

/**
 * Check if red dot should be displayed for Webinar
 * @param {*} redDotState
 * @param {*} webinarList
 */
export function checkDisplayWebinarRedDot(
  redDotState: MuleRedDotFeatureList,
  webinarList: WebinarItemState[],
): boolean {
  return (
    redDotState &&
    webinarList &&
    getDisplayRedDotWebinarEvent(redDotState, webinarList).length > 0
  );
}

/**
 * Return a list of webinar items which are required to display red dot
 * @param {*} redDotState
 * @param {*} webinarList
 */
export function getDisplayRedDotWebinarEvent(
  redDotState: MuleRedDotFeatureList,
  webinarList: WebinarItemState[],
): WebinarItemState[] {
  // Filter by
  // (1) check if the event is eligible for red dot checking AND
  // (2) check if the event has never been clicked
  return webinarList.filter((i) => {
    return isEligibleRedDotWebinerEvent(i) && !isEventClicked(redDotState, i);
  });
}

/**
 * Check if the event is eligbile to display red dot (not include 'clicked' checking)
 * @param {*} webinarItem
 */
function isEligibleRedDotWebinerEvent(webinarItem: WebinarItemState): boolean {
  const format = 'YYYY-MM-DD HH:mm:ss';
  const systemTime = moment(webinarItem.systemTime, format);
  const enrollStartTime = moment(
    `${webinarItem.enrolmentStartDate} ${webinarItem.enrolmentStartTime || ''}`,
    format,
  );
  const enrollEndTime = moment(
    `${webinarItem.enrolmentEndDate} ${webinarItem.enrolmentEndTime || ''}`,
    format,
  );
  return systemTime.isBetween(enrollStartTime, enrollEndTime);
}

/**
 * Check if the event has been clicked
 * @param {*} redDotState
 * @param {*} webinarItem
 */
function isEventClicked(
  redDotState: MuleRedDotFeatureList,
  webinarItem: WebinarItemState,
) {
  return (
    redDotState &&
    redDotState.features &&
    redDotState.features.some((f) => {
      return f.featureId.includes(webinarItem.campaignId);
    })
  );
}
